// Consent-gated PostHog loader: nothing is loaded/initialised before the user opts in.
const CONSENT_KEY = 'gmed_cookie_consent';
const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || 'phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs';
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

export const getConsent = () => {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const hasAnalyticsConsent = () => getConsent()?.analytics === true;

let loading = null;

const loadPostHogScript = () => {
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `${POSTHOG_HOST.replace('.i.posthog.com', '-assets.i.posthog.com')}/static/array.js`;
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return loading;
};

export const initAnalytics = async () => {
  if (!hasAnalyticsConsent()) return;

  if (!window.posthog?.__loaded) {
    try {
      await loadPostHogScript();
    } catch (e) {
      return;
    }
    window.posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      person_profiles: 'identified_only',
      disable_session_recording: true,
      session_recording: { recordCrossOriginIframes: true },
    });
  }

  window.posthog?.opt_in_capturing?.();
  window.posthog?.startSessionRecording?.();
};

export const disableAnalytics = () => {
  if (!window.posthog) return;
  // reset() clears persistence (including opt_out) and can restart recording,
  // so run it first; then stop the recording and opt out for good.
  window.posthog.reset?.();
  window.posthog.opt_out_capturing?.();
  window.posthog.stopSessionRecording?.();
};

export const applyAnalyticsConsent = (prefs) => {
  if (prefs?.analytics) {
    initAnalytics();
  } else {
    disableAnalytics();
  }
};
